export default {
      id: "sli-quarter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cf73de4e.svg#sli-quarter",
      toString: function () {
        return this.url;
      }
    }